module.exports = __webpack_public_path__ + "static/media/error.3a811bec.mp3";